__turbopack_context__.v({
  "canvas": "UltraSnapSection-module__gS_W1W__canvas",
  "canvasContainer": "UltraSnapSection-module__gS_W1W__canvasContainer",
  "description": "UltraSnapSection-module__gS_W1W__description",
  "heading": "UltraSnapSection-module__gS_W1W__heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "section": "UltraSnapSection-module__gS_W1W__section",
  "textContainer": "UltraSnapSection-module__gS_W1W__textContainer",
});
